
import { Component, Vue, Prop, Watch } from "vue-property-decorator"
import { CircularLoader } from "@coredination/components"

import TransportDocumentDetail from "@/graphql/transportdocument/transportdocumentdetail.graphql"
import CompleteTransportDocument from "@/graphql/transportdocument/completetransportdocument.graphql"
import DeleteTransportDocument from "@/graphql/transportdocument/deletetransportdocument.graphql"
import { navbar, NavbarOption } from "@/components/NavbarOptions.vue"


@Component({
    apollo: {
        transportDocument: {
            query: TransportDocumentDetail,
            skip() {
                return this.transportDocumentProp || !this.uuid
            },
            variables() {
                return { uuid: this.uuid }
            }
        }
    },
    components: {
        TransportDocumentWasteItem: () => import("./TransportDocumentWasteItem.vue"),
        SignatureField: () => import("@/components/fields/SignatureField.vue"),
        AreYouSureDialog: () => import("@/components/dialogs/AreYouSureDialog.vue"),
        CircularLoader
    },
})
export default class TransportDocumentView extends Vue {
    @Prop({ default: false })
    preview?: boolean
    @Prop({ default: null })
    uuid?: any
    @Prop({ default: null })
    transportDocumentProp: any
    
    transportDocument?: any = null
    saving: boolean = false
    showAreYouSure: boolean = false

    get navbarOptions(): NavbarOption[] {
        var options = []
        if (!this.preview) {
            options.push({
                title: this.$t("delete"),
                action: () => this.showAreYouSure = true
            })
            // TODO share option
        }
        return options
    }

    mounted() {
        if (this.transportDocumentProp)
            this.transportDocument = this.transportDocumentProp
        navbar?.setOptions(this.navbarOptions)
    }

    complete() {
        this.saving = true
        this.$apollo.mutate({
            mutation: CompleteTransportDocument,
            variables: { uuid: this.uuid }
        }).then(() => {
            this.$router.go(-2) // back to job
        }).catch((error: any) => {
            console.error(error)
        }).finally(() => {
            this.saving = false
        })
    }

    remove() {
        this.saving = true
        this.$apollo.mutate({
            mutation: DeleteTransportDocument,
            variables: { uuid: this.uuid  }
        }).then(() => {
            this.$router.go(-1) // back to job
        }).catch((error: any) => {
            console.error(error)
        }).finally(() => {
            this.saving = false
        })
    }

    get loading() {
        return this.$apollo.queries.transportDocument.loading
    }

    translateType(type: string) {
        return this.$t(`transportDocument_contactType_${type}`) as string
    }
}

